import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  borderColor: (p) => p.palette.grey[300],
  background: (p) => p.palette.grey[100],
  padding: (p) => p.spacing(1.5, 2),
  gap: (p) => p.spacing(1.5),
  position: 'sticky',
  top: 0,
  zIndex: 10,
};

export const card: SxStyle = {
  borderColor: (p) => p.palette.primary[200],
};

export const cardContent: SxStyle = {
  '&.MuiCardContent-root:last-child': { paddingBottom: 1.5 },
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[100],
  backgroundColor: (p) => p.palette.primary[300],
  borderRadius: '50%',
};
